import { createContext, useContext } from 'react';

/**
 * The DOM node of the Medical Profile tab bar's right-hand actions slot. The
 * active sub-tab (e.g. Observations) portals its own controls into it so they
 * sit beside the tabs instead of stacked above the tab's content. `null` until
 * the slot has mounted.
 */
export const TabActionsSlotContext = createContext<HTMLElement | null>(null);

export const useTabActionsSlot = (): HTMLElement | null =>
  useContext(TabActionsSlotContext);
